import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ListIncomeDuesChild from "./ListIncomeDuesChild";

const ListIncomeDues = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ListIncomeDuesChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ListIncomeDues;
